import { render, staticRenderFns } from "./ZonesBasic.vue?vue&type=template&id=606201f3&scoped=true&"
import script from "./ZonesBasic.vue?vue&type=script&lang=js&"
export * from "./ZonesBasic.vue?vue&type=script&lang=js&"
import style0 from "./ZonesBasic.vue?vue&type=style&index=0&id=606201f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606201f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VSpacer})
